export default __webpack_public_path__ + "static/waiting-7c0127bbaba526d49266541404848d8a.svg";